import React from 'react'
import ResetPasswordContainer from './ResetPasswordContainer'

const ResetPassword = props => <ResetPasswordContainer {...props} />

export default ResetPassword



// WEBPACK FOOTER //
// ./src/routes/ResetPassword/index.js